import styled from '@emotion/styled';

export const TagContainer = styled.div`
  position: relative;
  display: inline-flex;
  align-items: center;

  :hover .tag-tooltip {
    visibility: visible;
    opacity: 1;
  }

  span.tag-label {
    padding: 6px 10px;
    background-color: #e0e7ff;
    color: #1e3a8a;
    border-radius: 4px;
    font-size: 14px;
    cursor: pointer;
    svg {
      vertical-align: bottom;
    }
  }

  .tag-tooltip {
    visibility: hidden;
    position: absolute;
    top: 100%;
    left: 50%;
    transform: translateX(-50%);
    background-color: #fff;
    color: grey;
    padding: 15px 10px 15px 0px;
    border-radius: 4px;
    border: lightgrey 1px solid;
    box-shadow: 4px 4px 5px rgba(0, 0, 0, 0.1);
    font-size: 12px;
    white-space: nowrap;
    z-index: 10;
    opacity: 0;
    margin-top: 2px;

    ul {
      li {
        padding: 5px;
      }
    }
  }
`;
